import { Quaternion } from '@technology/web3d';
import { AlignmentNavigationCapability } from '@trimble/web3d-capabilities';
import { StationPathIndexProvider } from '@trimble/web3d-providers';
import { SyncFn } from './sync-coordinator';
import {
  followStation,
  getActiveNavCap,
  navigateAlongPath,
  updateFrustum,
} from './sync-source-helpers';
import {
  getStationSyncPosition,
  isStationOrientationMeaningful,
} from './source-positions';

/**
 * Syncs from a station/image source pane to an alignment target pane.
 * Reads the station from source and navigates the alignment tool in the
 * target, by path distance on the station's own mission path. Propagates source quaternion when source orientation is
 * meaningful (i.e. not Planar) and target is not in cross-section mode.
 */
export const syncStationToAlignment: SyncFn = async (source, target) => {
  const sync = getStationSyncPosition(source);
  if (!sync) return;

  const sourceViewer = source.viewerWrapper()?.viewer;
  const targetViewer = target.viewerWrapper()?.viewer;
  if (!sourceViewer || !targetViewer) return;

  const targetCap = getActiveNavCap(target);
  if (!(targetCap instanceof AlignmentNavigationCapability)) return;

  const propagateOrientation =
    isStationOrientationMeaningful(source) && !targetCap.crossSectionEnabled();

  await navigateAlongPath(
    sync,
    targetCap,
    target.get(StationPathIndexProvider)(),
    propagateOrientation
      ? new Quaternion(...sourceViewer.camera.quaternion.toArray())
      : undefined
  );
  followStation(targetCap, source, sync.stationKey);
  updateFrustum(
    target,
    sync.position,
    propagateOrientation ? sourceViewer.camera.quaternion.toArray() : null,
    null
  );
};
